export default __webpack_public_path__ + "static/media/login-payung-terbang.b44f6e89.svg";